import { OrderLineItemProps } from '../../types/types';
import { has3DApprovalActivity, isPending3DApproval } from '../../components/SalesOrders/ThreeDApproval/helpers';

export const getPending3DApprovalItems = (orderItems: OrderLineItemProps[]): OrderLineItemProps[] =>
    orderItems.filter(
        item => isPending3DApproval(item.production_3d_file_approval_status) && item.production_3d_file !== null
    );

export const shouldHide3DApprovalColumn = (orderItems: OrderLineItemProps[]): boolean =>
    !orderItems.some(
        item => has3DApprovalActivity(item.production_3d_file_approval_status) && item.production_3d_file !== null
    );
